<template>
  <div class="ftpItem">
    <div class="item auItem2">
      <el-form :model="Item" label-width="100px" class="userForm">
        <el-row type="flex" class="row-bg">
          <el-col :span="14">
            <el-form-item label="名称">
                <el-input v-model="Item.name"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="2"></el-col>
            <el-form-item label="运行状态">
                <el-input v-model="Item.triggerStatus" ></el-input>
            </el-form-item>
      </el-row>
      <el-row type="flex" class="row-bg">
          <el-col :span="14">
            <el-form-item label="开始执行时间">
                <el-input v-model="Item.taskStartTime"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="2"></el-col>
            <el-form-item label="下次执行时间">
                <el-input v-model="Item.nextRunTime" ></el-input>
            </el-form-item>
      </el-row>
      <el-row type="flex" class="row-bg">
          <el-col :span="14">
            <el-form-item label="周期类型">
                <el-input v-model="Item.periodType"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="2"></el-col>
            <el-form-item label="周期值">
                <el-input v-model="Item.periodValue" ></el-input>
            </el-form-item>
      </el-row>
      <el-row type="flex" class="row-bg">
          <el-col :span="14">
            <el-form-item label="定时任务说明">
                <el-input v-model="Item.desc"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="2"></el-col>
            <el-form-item label="任务类型">
                <el-input v-model="Item.type" ></el-input>
            </el-form-item>
      </el-row>
      <el-row type="flex" class="row-bg">
          <el-col :span="14">
            <el-form-item label="数据开始时间">
                <el-input v-model="Item.dataStartDate"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="2"></el-col>
            <el-form-item label="数据结束时间">
                <el-input v-model="Item.dataEndDate" ></el-input>
            </el-form-item>
      </el-row>
      <el-row type="flex" class="row-bg">
          <el-col :span="14">
            <el-form-item label="交付方式">
                <el-input v-model="Item.deliveryType"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="2"></el-col>
            <el-form-item label="订单状态">
                <el-input v-model="Item.status" ></el-input>
            </el-form-item>
      </el-row>
      </el-form>
    </div>
    <div class="center">
      <a href="javascript:;" @click="closeDialog" class="callback">确定</a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'subscriptionOrderDetail',
  props: ['model', 'dialogFormVisible'],
  data () {
    return {
      loading: false
    }
  },
  computed: {
    Item: {
      get () {
        return this.model
      }
    }
  },
  methods: {
    closeDialog() {
      this.$emit('onDialogVisible', false)
    }
  }
}
</script>

<style lang="less">
.ftpItem{
  position: relative;
  p{
    padding: 0 10px;
    border-top:1px solid #ddd;
    text-align: justify;
  }
  .item{
    padding: 0px 0px 10px;
    min-height: 110px;
    margin-bottom: 10px;
  }
  .auItem2{
    padding-top: 10px;
    .el-form-item__label{
      text-align: left;
    }
    .vcode{
      width: 50%;
      input{
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
      }
    }
    a{
      display: inline-block;
      width: 80px;
      height: 40px;
      background-color: #f55d54;
      text-align: center;
      vertical-align: bottom;
    }
  }
  .center{
    text-align: center;
    a{
      width: 60px;
      border-radius: 3px;
      font-size: 12px;
      background-color: #f56c6c;
      display: inline-block;
      padding:8px 10px;
      color: #fff;
      margin:0 25px;
    }
    .save{
      background-color: #409eff;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/order/SubscriptionOrderDetail.vue